import { minTsaiForSeats, type GameType, type SeatCount } from '@big2/shared';
import { useI18n } from '../../../i18n.js';

export interface TsaiLeaveWarningModalProps {
  seats: SeatCount;
  gameType: GameType;
  onStay: () => void;
  onConfirmAbandon: () => void;
}

export function TsaiLeaveWarningModal({
  seats,
  gameType,
  onStay,
  onConfirmAbandon,
}: TsaiLeaveWarningModalProps) {
  const { lang } = useI18n();
  const isMn = lang === 'mn';
  const minTsai = minTsaiForSeats(seats, gameType);

  return (
    <div
      className="modal-backdrop tsai-leave-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tsai-leave-warning-title"
      data-testid="tsai-leave-warning-modal"
      onClick={onStay}
    >
      <div
        className="modal-card tsai-leave-warning-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tsai-leave-warning-badge">
          🍵 {isMn ? 'ӨРСӨЛДӨӨНТ ЦАЙТАЙ ТОГЛОЛТ' : 'COMPETITIVE TSAI MATCH'}
        </div>

        <h3 id="tsai-leave-warning-title" className="tsai-leave-warning-title">
          ⚠️ {isMn ? 'Цайтай тоглолтоос гарах уу?' : 'Abandon Competitive Tsai Match?'}
        </h3>

        <p className="tsai-leave-warning-desc">
          {isMn
            ? 'Цайтай өрөөнд таны оронд бот орлож тоглохгүй. Хэрэв та одоо гарвал таны үлдсэн мод хасагдаж, ээлж автоматаар өнжигдөн энэ гараанд хамгийн сүүлийн байранд орж Цайны торгууль төлөх болно.'
            : 'In Competitive Tsai mode, you will NOT be replaced by a bot. Leaving now sets aside your remaining cards, auto-passes your turns while others finish the round, and places you last with a Tsai forfeit penalty.'}
        </p>

        <div className="tsai-leave-penalty-box">
          <span>{isMn ? 'Хамгийн багадаа хасагдах Цай:' : 'Minimum Tsai Forfeit Penalty:'}</span>
          <strong>-{minTsai} 🍵</strong>
        </div>

        <div className="tsai-leave-warning-actions">
          <button
            type="button"
            className="room-primary tsai-stay-btn"
            onClick={onStay}
          >
            {isMn ? 'Тоглолтод үлдэх' : 'Stay in Match'}
          </button>
          <button
            type="button"
            className="matchmaking-cancel-btn tsai-abandon-btn"
            onClick={onConfirmAbandon}
          >
            {isMn ? `Цай алдаад гарах (-${minTsai} 🍵)` : `Abandon & Forfeit (-${minTsai} 🍵)`}
          </button>
        </div>
      </div>
    </div>
  );
}
